import { createAction, props } from '@ngrx/store';
import { UpdateComplianceReportStatusRequest } from '../../api/models/update-compliance-report-status-request.model';
import { Contract } from '../../models/contract';

export enum ContractActionEnum {
    ComplianceStatusChanged = '[Compliance] Compliance Status Changed',
    CredentialingStatusChanged = '[Compliance] Credentialing Status Changed',
    ComplianceStatusChangeSuccess = '[Compliance] Compliance Status Change Succeeded',
    CredentialingStatusChangeSuccess = '[Compliance] Credentialing Status Change Succeeded',
    ComplianceStateChanged = '[Compliance] Compliance State Changed',
    ComplianceStateChangeSuccess = '[Compliance] Compliance State Change Succeeded',
    NoteChanged = '[Compliance] Compliance Note Changed',
    ContractChanged = '[Compliance] Contract Changed',
    DocumentChanged = '[Compliance] Document Changed'
}

export const complianceStatusChanged = createAction(
    ContractActionEnum.ComplianceStatusChanged,
    props<{ contractId: number; statusId: number }>()
);

export const credentialingStatusChanged = createAction(
    ContractActionEnum.CredentialingStatusChanged,
    props<{ contractId: number; statusId: number }>()
);

export const complianceStatusChangeSuccess = createAction(ContractActionEnum.ComplianceStatusChangeSuccess);
export const credentialingStatusChangeSuccess = createAction(ContractActionEnum.CredentialingStatusChangeSuccess);

export const complianceStateChanged = createAction(
    ContractActionEnum.ComplianceStateChanged,
    props<{ contractId: number; state: UpdateComplianceReportStatusRequest }>()
);
export const complianceStateChangeSuccess = createAction(ContractActionEnum.ComplianceStateChangeSuccess);

export const contractChanged = createAction(ContractActionEnum.ContractChanged, props<{ id: number }>());

export const documentChanged = createAction(ContractActionEnum.DocumentChanged, props<{ documentId: number }>());

export const loadContractsForCandidate = createAction(
    '[DOCUMENT REVIEWER] Load Contracts For Candidate',
    props<{ contractId?: number }>()
);
export const loadContractsForCandidateSuccess = createAction(
    '[DOCUMENT REVIEWER] Load Contracts For Candidate Success',
    props<{ contracts: Contract[] }>()
);
export const loadContractsForCandidateFailure = createAction(
    '[DOCUMENT REVIEWER] Load Contracts For Candidate Failed',
    props<{ error: unknown }>()
);

export const resetContracts = createAction('[DOCUMENT BATCH DETAILS] Reset Contracts');
